<template>
  <generic-trash
    v-model="selected"
    :getPag="getPagAux"
    :getExcel="getExcelAux"
    :getParams="getParamsAux"
    :doRestore="doRestoreAux"
    :doDelete="doDeleteAux"
    :FilterPanel="FilterPanel"
    :RouteName="RouteName"
    :dialogTitle="dialogTitle"
    :dialogMesage="dialogMesage"
    :ExcelName="ExcelName"
    :idVista="idVista"
    :HeaderTitle="HeaderTitle"
    :vuexnamespace="vuexnamespace"
    :PayloadSingleId="PayloadSingleId"
    :PayloadMultipleType="PayloadMultipleType"
  />
</template>

<script>
import { i18n } from '@/i18n'
import GenericTrash from '@/views/trash/GenericTrash.vue'
import CustomFilter from '@/components/filters/trash/CertificatesFilter.vue'
import { getCertificatesPag } from '@/services/certificates/getCertificatesPag'
import { downloadExcel } from '@/services/certificates/downloadExcel'
import { deleteTrashCert } from '@/services/trash/deleteTrashCert'
import { restoreTrashCert } from '@/services/trash/restoreTrashCert'

export default {
  name: 'vista-papelera-certificados',
  components: {
    GenericTrash,
  },
  data: function () {
    return {
      FilterPanel: CustomFilter,
      RouteName: 'certificates',
      dialogTitle: i18n.t('certificates.delete_certificate'),
      dialogMesage: i18n.t('app.delete_permanent_selected_confirmation', { entity: i18n.t('certificates.header').toLowerCase() }),
      ExcelName: 'certificados-borrados.xlsx',
      idVista: 29,
      HeaderTitle: i18n.t('trash.certificates'),
      vuexnamespace: 'trashCertificates',
      PayloadSingleId: ['idCliente', 'SerialNumber', 'TipoCertificado'],
      PayloadMultipleType: 'Array',
      selected: []
    }
  },
  methods: {
    getParamsAux (data) {
      return {
        serial: data.serial ? data.serial.value : null,
        commonName: data.name ? data.name.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
        fechaCaducidadDesde: data.expires_from ? data.expires_from.value : null,
        fechaCaducidadHasta: data.expires_to ? data.expires_to.value : null,
        tipoCert: data.tipoCert ? data.tipoCert.value : null,
      }
    },
    getPagAux: async function (objOrder, params) {
      return await getCertificatesPag(objOrder, params)
    },
    getExcelAux: async function (objOrder, params) {
      return await downloadExcel(objOrder, params)
    },
    doRestoreAux: async function (payload) {
      return await restoreTrashCert(payload)
    },
    doDeleteAux: async function (payload) {
      return await deleteTrashCert(payload)
    },
  }
}
</script>
